import { render, staticRenderFns } from "./SLMatch.vue?vue&type=template&id=0f55e1c3&"
import script from "./SLMatch.vue?vue&type=script&lang=js&"
export * from "./SLMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports